<script>
    import Button from "@smui/button/Button.svelte";
    import List, { Item, Text, PrimaryText, SecondaryText } from "@smui/list";
    import Textfield from "@smui/textfield";
    import FormField from "@smui/form-field";
    import Checkbox from "@smui/checkbox";

    import { post } from "../../http";

    import { getObject, setObject } from "../../session";
    import Select, { Option } from "@smui/select";
    import { navigate } from "svelte-routing";
    import { onMount } from "svelte";
    import title from "../../components/title";
    import snackbar from "../../components/snackbar";

    export let location;

    let weight = "1";
    let packages = [];
    let selectedPackage = null;
    let selectedKind;
    let isInsurance = false;
    let errorMsg = null;
    let total = 0;
    let price = 0;
    let insurance = 0;

    $: price && recalculate();
    $: updatePrice(selectedPackage, isInsurance);

    function updatePrice() {
        scrollBottom();
        recalculate();
    }

    function scrollBottom() {
        setTimeout(
            () =>
                window.scrollTo({
                    left: 0,
                    top: window.document.body.scrollHeight,
                    behavior: "smooth",
                }),
            100
        );
    }

    function recalculate() {
        if (selectedPackage == null) return;
        total = selectedPackage.tariff;
        if (isInsurance && price >= 500000) insurance = (price * 0.25) / 100;
        else insurance = 0;
    }

    function calculate() {
        const order = getObject("order");
        packages = [];
        insurance = 0;
        selectedPackage = null;

        post("/api/calculate_fee", {
            origin_code: order.origin_code,
            destination_code: order.destination_code,
            weight: weight,
        }).then((resp) => {
            if (resp.status == 0) {
                if (resp.data != null)
                    packages = resp.data.filter(
                        (val) =>
                            val.service == "BEST" ||
                            val.service == "SIUNT" ||
                            val.service == "GOKIL"
                    );
                if (packages.length == 1) selectedPackage = packages[0];
                else errorMsg = resp.message;
            } else {
                snackbar.open(resp.message);
            }
        });
    }

    function next() {
        const order = getObject("order");
        order["insurance"] = insurance + "";
        order["tarif"] = total + "";
        order["delivery_type"] = selectedPackage.service;
        order["delivery_type_description"] = selectedPackage.description;
        order["parcel_category"] = selectedKind;
        order["parcel_content"] = "-";
        order["parcel_value"] = price + "";
        order["parcel_weight"] = weight;
        setObject("order", order);
        navigate("/package/notes");
    }
    onMount(() => {
        title.set("Rincian paket");
    });
</script>

<div class="content padding-top">
    <div class="kind">
        <Select
            bind:value={selectedKind}
            variant="outlined"
            label="Kategori Paket"
            enhanced
        >
            <Option value="Paket">Paket</Option>
            <Option value="Dokumen">Dokumen</Option>
        </Select>
    </div>
    {#if selectedKind != ""}
        <div class="weight row gap vcenter">
            <div class="number">
                <Textfield
                    type="number"
                    input$step="0.1"
                    bind:value={weight}
                    variant="outlined"
                    label="Berat paket"
                    input$class="text-center"
                    input$placeholder="Berapa berat paketnya?"
                />
            </div>
            Kg
            <Button color="primary" variant="unelevated" on:click={calculate}>
                Hitung
            </Button>
        </div>
    {/if}
    {#if packages.length > 0}
        <div class="shipping-kind">
            {#if packages.length > 1}
                <div class="text">Pilih jenis pengiriman:</div>
            {/if}
            <List class="address" threeLine>
                {#each packages as pkg}
                    <Item on:SMUI:action={() => (selectedPackage = pkg)}>
                        <Text>
                            <PrimaryText>
                                {pkg.service}
                                -
                                {pkg.description}
                            </PrimaryText>
                            <SecondaryText>Estimasi: {pkg.etd}</SecondaryText>
                            <SecondaryText>Tarif: {pkg.tariff}</SecondaryText>
                        </Text>
                    </Item>
                {/each}
            </List>
        </div>
    {/if}
    {#if selectedPackage != null}
        <div class="padding">
            <div>
                Jika nilai barang lebih dari Rp500.000 bisa ditambahkan asuransi
            </div>
            <FormField>
                <Checkbox bind:checked={isInsurance} />
                <span slot="label">Tambahkan asuransi</span>
            </FormField>
        </div>
    {/if}
    {#if isInsurance}
        <div class="">
            <Textfield
                type="number"
                bind:value={price}
                variant="outlined"
                label="Harga barang"
                input$class="text-center"
                input$placeholder="Masukkan harga barang"
            />
        </div>
    {/if}
</div>
{#if selectedPackage != null}
    <div class="row total gap center">
        <div class="column fill">
            <div class="row">
                {#if isInsurance}
                    <div>Asuransi:</div>
                    <div class="fill" />
                    <div>{insurance}</div>
                {/if}
            </div>
            <div class="row">
                <div>Total Estimasi:</div>
                <div class="fill" />
                <div>Rp {total + insurance}</div>
            </div>
        </div>
        <div>
            <Button variant="unelevated" on:click={next}>OK</Button>
        </div>
    </div>
{/if}
<div id="bottom" />

<style lang="scss">
    @import "../../styles/colors";
    .weight {
        & .number {
            width: 136px;
        }
    }
    .kind {
        padding-top: 8px;
    }
    .shipping-kind {
        background-color: #eee;
        padding-top: 16px;

        & .text {
            padding: 8px 16px;
        }
    }

    .total {
        height: 48px;
        row-gap: 8px;
        padding: 16px;
        background-color: $col-secondary;
        color: $col-on-secondary;
        position: fixed;
        left: 0;
        bottom: 0;
        right: 0;
    }
    #bottom {
        height: 48px;
    }

    .content {
        margin-bottom: 48px;
    }
</style>
